import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CuCustomerService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/cu-customers', params);
    }

    store(body: any) {
        return super.post('/cu-customers', body);
    }

    edit(cuCustomerId: string | number) {
        return super.get(`/cu-customers/${cuCustomerId}/edit`);
    }

    update(cuCustomerId: string | number, body: any) {
        return super.put(`/cu-customers/${cuCustomerId}`, body);
    }

    destroy(cuCustomerId: string | number) {
        return super.delete(`/cu-customers/${cuCustomerId}`);
    }

    sendToIntranet(cuCustomerId: string | number) {
        return super.post(`/cu-customers/${cuCustomerId}/send-to-intranet`);
    }

    syncMaPricesToIntranetCount(cuCustomerId: string | number) {
        return super.get(`/cu-customers/${cuCustomerId}/sync-ma-prices-to-intranet/count`);
    }

    syncMaPricesToIntranet(cuCustomerId: string | number) {
        return super.post(`/cu-customers/${cuCustomerId}/sync-ma-prices-to-intranet`);
    }

    select(params: any = {}) {
        return super.get('/cu-customers/select', params);
    }

    reserveId(homecare: boolean, id: number | null = null) {
        return super.post('/cu-customers/create/reserve-id', {homecare, id});
    }

    releaseId(id: number) {
        return super.post(`/cu-customers/create/release-id`, {id});
    }

    comments(cuCustomerId: string | number, params: any = {}) {
        return super.get(`/cu-customers/${cuCustomerId}/comments`, params);
    }

    internalComments(cuCustomerId: string | number, params: any = {}) {
        return super.get(`/cu-customers/${cuCustomerId}/internal-comments`, params);
    }
}
